interface LexicalText {
  children?: LexicalText[];
  type: 'paragraph' | 'text' | 'linebreak' | 'listitem';
  text?: string;
}

const listNewLineTypes = ['paragraph', 'linebreak', 'listitem'];

const decompose = (list: LexicalText[]): string => {
  const regExp = /[ ]{2,}/g;

  return list
    .map((item) => {
      const prefix = listNewLineTypes.includes(item.type) ? ' ' : '';

      if (item?.children) {
        return prefix + decompose(item.children);
      }
      return prefix + (item.text || '');
    })
    .join('')
    .replaceAll(regExp, ' ');
};

export const useLexicalText = () => {
  return (input: string) => {
    try {
      const lexicalObject = JSON.parse(input);
      return decompose(lexicalObject.root?.children).trim();
    } catch {
      return '';
    }
  };
};
